import { render, staticRenderFns } from "./UserDropdownContainer.vue?vue&type=template&id=d83f89b8"
import script from "./UserDropdownContainer.vue?vue&type=script&lang=js"
export * from "./UserDropdownContainer.vue?vue&type=script&lang=js"
import style0 from "./UserDropdownContainer.vue?vue&type=style&index=0&id=d83f89b8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports